import { materialService } from '_services';
import { session } from '_helpers';
import { ACTIONS_MATERIAL } from '_constants/material.constants';
import alertActions from './alert.actions';

export const receiveMaterials = (materials) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < materials.length; i++) {
    byIdObjectToDispatch[materials[i].materialID] = materials[i];
  }

  return {
    type: ACTIONS_MATERIAL.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteMaterial = (materialId) => ({
  type: ACTIONS_MATERIAL.DELETE,
  byId: { [materialId]: null }
});

const getMaterials = (accountID) => async (dispatch) => {
  try {
    const resp = await materialService.getAll(accountID);
    if (resp?.[0]?.materialID) {
      dispatch(receiveMaterials(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving materials.', e));
  }
  return null;
};

const getMaterial = (materialID) => async (dispatch) => {
  try {
    const resp = await materialService.getById(materialID);
    if (resp?.materialID) {
      dispatch(receiveMaterials([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving material #${materialID}.`, e));
  }
  return null;
};

const addMaterial = (material) => async (dispatch) => {
  try {
    const resp = await materialService.create(material);
    if (resp?.materialID && !resp.parentMaterialID) {
      dispatch(receiveMaterials([ resp ]));
    }
    return resp;
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updMaterial = (material) => async (dispatch) => {
  try {
    const resp = await materialService.update(material);
    if (resp?.materialID) {
      dispatch(receiveMaterials([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delMaterial = (materialID) => async (dispatch) => {
  try {
    const resp = await materialService.delete(materialID);
    if (resp?.materialID) {
      dispatch(deleteMaterial(resp.materialID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing material #${materialID}.`, e));
  }
  return null;
};

const materialActions = {
  getMaterials,
  getMaterial,
  addMaterial,
  updMaterial,
  delMaterial
};

export default materialActions;
